import { render } from "./AssistenzaTecnica_nascosto_risposti.vue?vue&type=template&id=120a7cc6&scoped=true"
import script from "./AssistenzaTecnica_nascosto_risposti.vue?vue&type=script&lang=js"
export * from "./AssistenzaTecnica_nascosto_risposti.vue?vue&type=script&lang=js"

import "./AssistenzaTecnica_nascosto_risposti.vue?vue&type=style&index=0&id=120a7cc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120a7cc6"]])

export default __exports__